export default "https://cdn-static.gokick.com/assets/89c12df47656b56f32e50d5631dab02a560652ab/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";